import AntdInputNumber from 'antd/lib/input-number';
import React           from 'react';

export type InputNumberProps = FieldProps & {
	min?: number;
	max?: number;
	formatter?: (value?: number) => string;
	parser?: (value?: string) => number;
	precision?: number;
	prefix?: React.ReactNode;
	value?: number;
	addonAfter?: React.ReactNode;
	addonBefore?: React.ReactNode;
	suffix?: React.ReactNode;
	step?: number | string;
	stringMode?: boolean;
	controls?: boolean;
	changeOnWheel?: boolean;
	onClick?: React.MouseEventHandler<HTMLInputElement>;
	onBlur?: React.FocusEventHandler<any> | undefined;
	onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>;
	onAfterChange?: (value?: number) => void;
	className?: string;
}

export default function InputNumber(props: InputNumberProps) {
	/**
	 * `onAfterChange` ne signale qu'une valeur saisie DANS ce champ, jamais une valeur posée par le
	 * parent : l'effet ci-dessous se déclenche sur `value`, qui change aussi au montage et à chaque
	 * fois que le parent en impose une nouvelle. Ce drapeau distingue les deux.
	 */
	const edited = React.useRef(false);

	React.useEffect(() => {
		if (!props.onAfterChange || !edited.current) {
			return;
		}

		const timer = setTimeout(() => {
			edited.current = false;

			if (props.value) {
				props.onAfterChange?.(props.value);
			}
		}, 400);
		return () => {
			clearTimeout(timer);
		};
	}, [props.value]);

	return (
		<AntdInputNumber
			{...(props.addonAfter !== undefined ? { addonAfter: props.addonAfter } : {})}
			{...(props.addonBefore !== undefined ? { addonBefore: props.addonBefore } : {})}
			formatter={props.formatter}
			id={props.id ? `input-number-${props.id}` : undefined}
			parser={props.parser ?? ((value) => parseFloat(value?.replace(',', '.') ?? '0'))}
			precision={props.precision}
			prefix={props.prefix}
			placeholder={props.placeholder}
			autoFocus={props.autoFocus}
			disabled={props.disabled}
			onChange={value => {
				edited.current = true;
				props.onChange?.(value);
			}}
			onBlur={props.onBlur}
			size={props.size}
			suffix={props.suffix}
			value={props.value}
			style={props.style}
			max={props.max}
			min={props.min}
			step={props.step}
			stringMode={props.stringMode}
			controls={props.controls}
			onPressEnter={props.onPressEnter}
			className={props.className}
			changeOnWheel={props.changeOnWheel}
			onClick={props.onClick}
		/>
	);
}
